import DateFnsUtils from "@date-io/date-fns";
import { Checkbox, FormControl, InputLabel, Paper, Radio, Select, TextField, Typography, withStyles, FormControlLabel, MenuItem } from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import { TramOutlined } from "@material-ui/icons";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { useEffect, useReducer, useState } from "react";
import iconDate from '../../assets/ic_book_ddt.png';
import iconClose from '../../assets/ic_close.png';
import { useStyles } from "../../library/selectOption";
import PreviewKategoriSkrining from "./previewKategoriSkrining";
import { format } from 'date-fns';
import api from "../api";
import { useHistory } from "react-router-dom";

const GreenRadio = withStyles({
    root: {
        color: green[400],
        '&$checked': {
            color: green[600],
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

const GreenCheckbox = withStyles({
    root: {
        color: green[400],
        '&$checked': {
            color: green[600],
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

export default function PreviewSkrining(props) {
    const classes = useStyles()
    const [visibleSkrining, setVisibleSkrining] = useState(false)
    const [visibleKategoriSkrining, setVisibleKategoriSkrining] = useState(false)
    let [pertanyaanLength, setPertanyaanLength] = useState([])
    const history = useHistory()
    useEffect(() => {
        console.log(props);
        setVisibleSkrining(true)
        setPertanyaanLength(props.data)
        forceUpdate()
    }, [])

    console.log(props);

    const handleCheckbox = (index, indexs) => {
        let id = pertanyaanLength.opsi[index].jawabanCheckbox.findIndex((val) => val === pertanyaanLength.opsi[index].opsi[indexs].jawaban)
        if (id > -1) {
            return true
        } else {
            return false
        }
    }

    const handleCheck = (val, index, indexs, indexss) => {
        let check = val
        console.log(pertanyaanLength.opsi[index]);
        if (pertanyaanLength.opsi[index].jawabanCheckbox.length > 0) {
            let idCheck = pertanyaanLength.opsi[index].jawabanCheckbox.findIndex((value) => value === check)
            if (idCheck > -1) {
                pertanyaanLength.opsi[index].jawabanCheckbox.splice(idCheck, 1)
            } else {
                pertanyaanLength.opsi[index].jawabanCheckbox.push(check)
            }
        } else {
            pertanyaanLength.opsi[index].jawabanCheckbox.push(check)
        }
        console.log(pertanyaanLength);
    }

    const handleCheckboxSub = (index, indexs, indexss) => {
        let id = pertanyaanLength.opsi[index].opsi[indexs].pendukung.jawabanCheckbox.findIndex((val) => val === pertanyaanLength.opsi[index].opsi[indexs].pendukung.opsi[indexss].jawaban)
        if (id > -1) {
            return true
        } else {
            return false
        }
    }

    const handleCheckSub = (val, index, indexs, indexss) => {
        let check = val
        console.log(pertanyaanLength.opsi[index]);
        if (pertanyaanLength.opsi[index].opsi[indexs].pendukung.jawabanCheckbox.length > 0) {
            let idCheck = pertanyaanLength.opsi[index].opsi[indexs].pendukung.jawabanCheckbox.findIndex((value) => value === check)
            if (idCheck > -1) {
                pertanyaanLength.opsi[index].opsi[indexs].pendukung.jawabanCheckbox.splice(idCheck, 1)
            } else {
                pertanyaanLength.opsi[index].opsi[indexs].pendukung.jawabanCheckbox.push(check)
            }
        } else {
            pertanyaanLength.opsi[index].opsi[indexs].pendukung.jawabanCheckbox.push(check)
        }
        console.log(pertanyaanLength);
    }

    const handleArrayOpsi = () => {
        console.log(pertanyaanLength.opsi)
        let sbf = {
            "question_name": "",
            "question_type": "",
            "scoring_type": "",
            "submenu_type": "",
            "is_mandatory": true,
            "answer": [],
            "submenu": null
        }
        let arrayQues = []
        let ar = []
        let array = []

        pertanyaanLength.opsi.map((items, index) => {
            items.opsi.map((itemss, indexss) => {
                if (itemss.submenu.value === "Tambahkan Submenu Pertanyaan" && items.subMenu === true) {
                    let subAr = []
                    itemss.pendukung.subMenu === true && itemss.pendukung.opsi.map((itemsss, indexss) => {
                        if (itemsss.submenu.value === "Tambahkan Submenu Pertanyaan") {
                            subAr.push({
                                "id": itemsss.pendukung.id,
                                "question_name": itemsss.pendukung.pertanyaan,
                                "question_type": itemsss.pendukung.tipe.value,
                                "scoring_type": itemsss.pendukung.tipeSkoring === "" ? "Tidak Ada Nilai" : itemsss.pendukung.tipeSkoring.value,
                                "submenu_type": itemsss.pendukung.subMenu === true ? 'Tambahkan Submenu Pertanyaan' : 'Tanpa Submenu',
                                "is_mandatory": itemsss.pendukung.mandatory === undefined ? false : itemsss.pendukung.mandatory,
                                "answer":
                                    itemsss.pendukung.tipe.value === 'Jawaban Singkat' || itemsss.pendukung.tipe.value === 'Tanggal' ?
                                        [{
                                            "answer": itemsss.pendukung.jawaban,
                                            "score": 0
                                        }]
                                        :
                                        itemsss.pendukung.opsi.map((i, index) => {
                                            return ({
                                                "answer": i.jawaban,
                                                "score": i.skor === "" ? 0 : Number(i.skor),
                                                "submenu_id": i.pendukung ? i.pendukung.id : null
                                            })
                                        }),

                            })
                        }
                    })
                    ar.push({
                        "id": itemss.pendukung.id,
                        "question_name": itemss.pendukung.pertanyaan,
                        "question_type": itemss.pendukung.tipe.value,
                        "scoring_type": itemss.pendukung.tipeSkoring === "" ? "Tidak Ada Nilai" : itemss.pendukung.tipeSkoring.value,
                        "submenu_type": itemss.pendukung.subMenu === true ? 'Tambahkan Submenu Pertanyaan' : 'Tanpa Submenu',
                        "is_mandatory": itemss.pendukung.mandatory === undefined ? false : itemss.pendukung.mandatory,
                        "answer":
                            itemss.pendukung.tipe.value === 'Jawaban Singkat' || itemss.pendukung.tipe.value === 'Tanggal' ?
                                [{
                                    "answer": itemss.pendukung.jawaban,
                                    "score": 0,
                                    "submenu_id": null
                                }]
                                :
                                itemss.pendukung.opsi.map((i, index) => {
                                    return ({
                                        "answer": i.jawaban,
                                        "score": i.skor === "" ? 0 : Number(i.skor),
                                        "submenu_id": i.pendukung ? i.pendukung.id : null
                                    })
                                }),
                        "submenu": subAr
                    })
                    // console.log(ar);
                } else {
                    return itemss != null;
                }
            })
            console.log(ar);
            // console.log(items);
            let ada = false
            if (ar.length > 0) {
                let idx = items.opsi.findIndex((val) => val.pendukung.id === ar[0].id)
                console.log(idx);
                if (idx > -1) {
                    ada = true
                } else {
                    ada = false
                }
            }
            ar.map((items) => {
                console.log(items);
                array.filter(function (el) {
                    return el != null;
                });
            })
            arrayQues.push({
                ...sbf,
                "id": null,
                "question_name": items.pertanyaan,
                "question_type": items.tipe.value,
                "scoring_type": items.tipeSkoring === "" ? "Tidak Ada Nilai" : items.tipeSkoring.value,
                "submenu_type": items.subMenu === true ? 'Tambahkan Submenu Pertanyaan' : 'Tanpa Submenu',
                "is_mandatory": items.mandatory === undefined ? false : items.mandatory,
                "answer":
                    items.tipe.value === 'Jawaban Singkat' || items.tipe.value === 'Tanggal' ?
                        [{
                            "answer": items.jawaban,
                            "score": 0,
                            "submenu_id": null
                        }]
                        :
                        items.opsi.map((i, index) => {
                            return ({
                                "answer": i.jawaban,
                                "score": i.skor === "" ? 0 : Number(i.skor),
                                "submenu_id": i.pendukung ? i.pendukung.id : null
                            })
                        }),
                "submenu": ada === true ? ar : []
            })
        })

        console.log(arrayQues)

        pertanyaanLength.question = arrayQues
        console.log(pertanyaanLength);
        if (pertanyaanLength.kategori.length < 1 ) {
            handleCreateSkrining()
        }
    }

    const handleCreateSkrining = () => {

        let tgl = new Date(props.data.tanggalBerlaku)
        let tanggal = format(tgl, 'yyyy-MM-dd')
        let af = {
            "valid_date": tanggal,
            "form_title": props.data.judul,
            "description": props.data.deskripsi,
            "categories": [],
            "question": pertanyaanLength.question
        }
        api.create().createScrenning(af).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    history.goBack()
                } else {
                    if (response.data.data.valid_date === "valid date sudah ada sebelumnya.") {
                        alert("valid date sudah ada sebelumnya.")
                    }
                }
            }
        })
        console.log(af);
    }

    const forceUpdate = useReducer(bool => !bool)[1];
    return (
        <div style={{ maxHeight: props.height - 100, overflow: 'scroll' }}>
            {visibleSkrining && (
                <div style={{ padding: 20, maxHeight: props.height - 100, overflow: 'scroll' }}>
                    <Paper style={{ width: "100%", borderRadius: 20, boxShadow: '5px 5px 10px 0 #999999', padding: '30px 20px 30px 20px' }}>
                        <div style={{ borderBottomColor: '#ebebeb', borderBottomStyle: 'solid', borderBottomWidth: 1, paddingBottom: 10 }}>
                            <Typography style={{ fontSize: 18, fontWeight: 'bold' }}>Tanggal Berlaku</Typography>
                        </div>
                        <div style={{ borderBottomColor: '#ebebeb', borderBottomStyle: 'solid', borderBottomWidth: 1, marginTop: 20, display: 'flex' }}>
                            <img src={iconDate} style={{ width: 20, height: 20, alignSelf: 'center' }} />
                            <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ margin: 0 }}>
                                <DatePicker
                                    margin="normal"
                                    disabled
                                    id="validFrom"
                                    label=""
                                    format="dd/MM/yyyy"
                                    value={new Date(pertanyaanLength.tanggalBerlaku)}
                                    onChange={(date) => {

                                    }}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    style={{ width: '100%', marginLeft: 20, padding: 0 }}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                    </Paper>

                    <Paper style={{ width: "100%", borderRadius: 20, boxShadow: '5px 5px 10px 0 #999999', padding: '30px 20px 30px 20px', marginTop: 20 }}>
                        <TextField
                            style={{ width: '100%', justifyContent: 'flex-end' }}
                            required={true}
                            disabled
                            // helperText={textkodeDokter}
                            placeholder={`Judul Formulir`}
                            onChange={(e) => {

                            }}
                            inputProps={{
                                style: {
                                    fontSize: 30,
                                    fontWeight: 'bold'
                                }
                            }}
                            InputLabelProps={{
                                style: {
                                    fontSize: 14,
                                    color: '#7e8085',
                                }
                            }}
                            value={pertanyaanLength.judul === "" ? "Judul Formulir" : pertanyaanLength.judul}
                        />
                        <TextField
                            style={{ width: '100%', justifyContent: 'flex-end', marginTop: 20 }}
                            disabled
                            // error={errorKodeDokter}
                            // helperText={textkodeDokter}
                            placeholder={`Deskripsi Formulir`}
                            onChange={(e) => {
                            }}
                            inputProps={{
                                style: {
                                    fontSize: 18,
                                }
                            }}
                            InputLabelProps={{
                                style: {
                                    fontSize: 14,
                                    color: '#7e8085',
                                }
                            }}
                            value={pertanyaanLength.deskripsi === "" ? "Deskripsi Formulir" : pertanyaanLength.deskripsi}
                        />
                    </Paper>
                    {pertanyaanLength.opsi && pertanyaanLength.opsi.map((item, index) => (
                        <div style={{ paddingTop: 30, borderRadius: 20 }}>
                            <div style={{ width: '100%', borderRadius: 20, boxShadow: '5px 5px 10px 0 #999999', scrollBehavior: true }} >
                                <Paper style={{ width: "100%", padding: 20 }}>
                                    <div style={{ marginTop: -10 }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <div style={{ width: "70%", borderBottomColor: 'black', borderBottomWidth: 1, borderBottomStyle: 'solid', paddingBottom: 10, alignSelf: 'flex-end' }} >
                                                <Typography style={{ alignSelf: 'flex-end', fontSize: 20, fontWeight: 'bold' }}>{item.pertanyaan}</Typography>
                                            </div>

                                            <div style={{ width: "28%", borderBottomColor: 'black', borderBottomWidth: 1, borderBottomStyle: 'solid', alignSelf: 'flex-end' }} >
                                                <Typography style={{}}>{item.tipe.value}</Typography>
                                            </div>
                                        </div>

                                        {item.tipe.value === 'Jawaban Singkat' || item.tipe.value === 'Jawaban Paragraf' ?
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
                                                <TextField
                                                    style={{ width: '70%' }}
                                                    id="jawab"
                                                    multiline
                                                    name="jawab"
                                                    required={true}
                                                    // error={errorKodeDokter}
                                                    // helperText={textkodeDokter}
                                                    placeholder={`Exp Jawaban Pertanyaan ${index + 1}`}
                                                    onChange={(e) => {
                                                        pertanyaanLength.opsi[index].jawaban = e.target.value
                                                        forceUpdate()
                                                    }}
                                                    inputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                        }
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 14,
                                                            color: '#7e8085',
                                                        }
                                                    }}
                                                    value={item.jawaban}
                                                />

                                                <TextField
                                                    style={{ width: '28%', alignSelf: 'flex-end' }}
                                                    id="jawab"
                                                    name="jawab"
                                                    disabled
                                                    placeholder={`Skoring`}
                                                    onChange={(e) => {
                                                        pertanyaanLength.opsi[index].skor = e.target.value
                                                        console.log(pertanyaanLength);
                                                        forceUpdate()
                                                    }}
                                                    inputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                        }
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 14,
                                                            color: '#7e8085',
                                                        }
                                                    }}
                                                    value={item.skor}
                                                />
                                            </div>
                                            :
                                            item.tipe.value === 'Pilihan Ganda' ?
                                                item.opsi && item.opsi.map((i, idx) => (
                                                    pertanyaanLength.opsi[index].subMenu ?
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
                                                            <div style={{ display: 'flex', width: '70%' }}>
                                                                <GreenRadio
                                                                    checked={pertanyaanLength.opsi[index].jawaban === i.submenu.value ? true : false}
                                                                    onChange={(e) => {
                                                                        pertanyaanLength.opsi[index].jawaban = i.submenu.value
                                                                        console.log(pertanyaanLength);
                                                                        forceUpdate()
                                                                    }}
                                                                    // value="c"
                                                                    name="radio"
                                                                    style={{ padding: 0 }}
                                                                    inputProps={{ 'aria-label': 'C' }}
                                                                />
                                                                <TextField
                                                                    style={{ marginLeft: 10, width: '60%' }}
                                                                    id="jawab"
                                                                    name="jawab"
                                                                    disabled
                                                                    placeholder={`Opsi Pilihan ${idx + 1}`}
                                                                    onChange={(e) => {
                                                                        pertanyaanLength.opsi[index].opsi[idx].jawaban = e.target.value
                                                                        console.log(pertanyaanLength);
                                                                        forceUpdate()
                                                                    }}
                                                                    inputProps={{
                                                                        style: {
                                                                            fontSize: 14,
                                                                        }
                                                                    }}
                                                                    InputLabelProps={{
                                                                        style: {
                                                                            fontSize: 14,
                                                                            color: '#7e8085',
                                                                        }
                                                                    }}
                                                                    value={i.jawaban}
                                                                />
                                                                {/* <img src={iconClose} style={{ width: 20, height: 20, alignSelf: 'center', marginLeft: 20, cursor: 'pointer' }}
                                                                onClick={() => {
                                                                    pertanyaanLength.opsi[index].opsi.splice(idx, 1)
                                                                    console.log(pertanyaanLength);
                                                                    forceUpdate()
                                                                }} /> */}
                                                            </div>
                                                            <TextField
                                                                style={{ width: '28%' }}
                                                                id="jawab"
                                                                name="jawab"
                                                                disabled
                                                                placeholder={`Skoring`}
                                                                onChange={(e) => {
                                                                    pertanyaanLength.opsi[index].opsi[idx].skor = e.target.value
                                                                    console.log(pertanyaanLength);
                                                                    forceUpdate()
                                                                }}
                                                                inputProps={{
                                                                    style: {
                                                                        fontSize: 14,
                                                                    }
                                                                }}
                                                                InputLabelProps={{
                                                                    style: {
                                                                        fontSize: 14,
                                                                        color: '#7e8085',
                                                                    }
                                                                }}
                                                                value={i.skor}
                                                            />
                                                        </div> :
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
                                                            <div style={{ display: 'flex', width: '70%' }}>
                                                                <GreenRadio
                                                                    checked={pertanyaanLength.opsi[index].jawaban === i.jawaban ? true : false}
                                                                    onChange={(e) => {
                                                                        pertanyaanLength.opsi[index].jawaban = i.jawaban
                                                                        console.log(pertanyaanLength);
                                                                        forceUpdate()
                                                                    }}
                                                                    // value="c"
                                                                    name="radio"
                                                                    style={{ padding: 0 }}
                                                                    inputProps={{ 'aria-label': 'C' }}
                                                                />
                                                                <TextField
                                                                    style={{ marginLeft: 10, width: '60%' }}
                                                                    id="jawab"
                                                                    name="jawab"
                                                                    disabled
                                                                    placeholder={`Opsi Pilihan ${idx + 1}`}
                                                                    onChange={(e) => {
                                                                        pertanyaanLength.opsi[index].opsi[idx].jawaban = e.target.value
                                                                        console.log(pertanyaanLength);
                                                                        forceUpdate()
                                                                    }}
                                                                    inputProps={{
                                                                        style: {
                                                                            fontSize: 14,
                                                                        }
                                                                    }}
                                                                    InputLabelProps={{
                                                                        style: {
                                                                            fontSize: 14,
                                                                            color: '#7e8085',
                                                                        }
                                                                    }}
                                                                    value={i.jawaban}
                                                                />
                                                                {/* <img src={iconClose} style={{ width: 20, height: 20, alignSelf: 'center', marginLeft: 20, cursor: 'pointer' }}
                                                            onClick={() => {
                                                                pertanyaanLength.opsi[index].opsi.splice(idx, 1)
                                                                console.log(pertanyaanLength);
                                                                forceUpdate()
                                                            }} /> */}
                                                            </div>
                                                            <TextField
                                                                style={{ width: '28%' }}
                                                                id="jawab"
                                                                name="jawab"
                                                                disabled
                                                                placeholder={`Skoring`}
                                                                onChange={(e) => {
                                                                    pertanyaanLength.opsi[index].opsi[idx].skor = e.target.value
                                                                    console.log(pertanyaanLength);
                                                                    forceUpdate()
                                                                }}
                                                                inputProps={{
                                                                    style: {
                                                                        fontSize: 14,
                                                                    }
                                                                }}
                                                                InputLabelProps={{
                                                                    style: {
                                                                        fontSize: 14,
                                                                        color: '#7e8085',
                                                                    }
                                                                }}
                                                                value={i.skor}
                                                            />
                                                        </div>
                                                ))
                                                :
                                                item.tipe.value === 'Kotak Centang' ?
                                                    item.opsi && item.opsi.map((i, idx) => (
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
                                                            <div style={{ display: 'flex', width: '70%' }}>
                                                                <FormControlLabel
                                                                    style={{ padding: 0, margin: 0 }}
                                                                    control={
                                                                        <GreenCheckbox
                                                                            checked={handleCheckbox(index, idx)}
                                                                            onChange={() => {
                                                                                handleCheck(i.jawaban, index, idx)
                                                                                forceUpdate()
                                                                            }}
                                                                            name="checked" />
                                                                    }
                                                                    label=""
                                                                />
                                                                <TextField
                                                                    style={{ marginLeft: 10, width: '95%' }}
                                                                    id="jawab"
                                                                    name="jawab"
                                                                    required={true}
                                                                    placeholder={`Opsi Pilihan ${idx + 1}`}
                                                                    onChange={(e) => {
                                                                        pertanyaanLength.opsi[index].opsi[idx].jawaban = e.target.value
                                                                        console.log(pertanyaanLength);
                                                                        forceUpdate()
                                                                    }}
                                                                    inputProps={{
                                                                        style: {
                                                                            fontSize: 14,
                                                                        }
                                                                    }}
                                                                    InputLabelProps={{
                                                                        style: {
                                                                            fontSize: 14,
                                                                            color: '#7e8085',
                                                                        }
                                                                    }}
                                                                    value={i.jawaban}
                                                                />
                                                            </div>
                                                            <TextField
                                                                style={{ width: '28%' }}
                                                                id="jawab"
                                                                name="jawab"
                                                                required={true}
                                                                placeholder={`Skoring`}
                                                                onChange={(e) => {
                                                                    pertanyaanLength.opsi[index].opsi[idx].skor = e.target.value
                                                                    console.log(pertanyaanLength);
                                                                    forceUpdate()
                                                                }}
                                                                inputProps={{
                                                                    style: {
                                                                        fontSize: 14,
                                                                    }
                                                                }}
                                                                InputLabelProps={{
                                                                    style: {
                                                                        fontSize: 14,
                                                                        color: '#7e8085',
                                                                    }
                                                                }}
                                                                value={i.skor}
                                                            />
                                                        </div>
                                                    ))
                                                    :
                                                    item.tipe.value === 'Tanggal' ?
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
                                                            <div style={{ borderBottomColor: '#ebebeb', borderBottomStyle: 'solid', borderBottomWidth: 1, display: 'flex', width: '70%' }}>
                                                                <img src={iconDate} style={{ width: 20, height: 20, alignSelf: 'center' }} />
                                                                <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ margin: 0 }}>
                                                                    <DatePicker
                                                                        margin="normal"
                                                                        id="validFrom"
                                                                        label=""
                                                                        format="dd MMM yyyy"
                                                                        value={new Date(pertanyaanLength.opsi[index].jawaban)}
                                                                        onChange={(date) => {
                                                                            pertanyaanLength.opsi[index].jawaban = new Date(date).toLocaleDateString()
                                                                            console.log(pertanyaanLength);
                                                                            forceUpdate()
                                                                        }}
                                                                        KeyboardButtonProps={{
                                                                            'aria-label': 'change date',
                                                                        }}
                                                                        style={{ width: '100%', margin: '0px 0px 0px 20px', padding: 0 }}
                                                                    />
                                                                </MuiPickersUtilsProvider>
                                                            </div>
                                                            <TextField
                                                                style={{ width: '28%', alignSelf: 'flex-end' }}
                                                                id="jawab"
                                                                name="jawab"
                                                                required={true}
                                                                placeholder={`Skoring`}
                                                                onChange={(e) => {
                                                                    pertanyaanLength.opsi[index].skor = e.target.value
                                                                    console.log(pertanyaanLength);
                                                                    forceUpdate()
                                                                }}
                                                                inputProps={{
                                                                    style: {
                                                                        fontSize: 14,
                                                                    }
                                                                }}
                                                                InputLabelProps={{
                                                                    style: {
                                                                        fontSize: 14,
                                                                        color: '#7e8085',
                                                                    }
                                                                }}
                                                                value={item.skor}
                                                            />
                                                        </div>
                                                        :
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
                                                            <TextField
                                                                style={{ width: '70%' }}
                                                                id="jawab"
                                                                name="jawab"
                                                                disabled
                                                                required={true}
                                                                placeholder={`Exp Jawaban Pertanyaan ${index + 1}`}
                                                                onChange={(e) => {

                                                                }}
                                                                inputProps={{
                                                                    style: {
                                                                        fontSize: 14,
                                                                    }
                                                                }}
                                                                InputLabelProps={{
                                                                    style: {
                                                                        fontSize: 14,
                                                                        color: '#7e8085',
                                                                    }
                                                                }}
                                                                value={item.jawaban}
                                                            />

                                                            <div style={{ width: "28%", borderBottomColor: 'black', borderBottomWidth: 1, borderBottomStyle: 'solid', alignSelf: 'flex-end' }} >
                                                                <Typography style={{}}>Skoring</Typography>
                                                            </div>
                                                        </div>
                                        }
                                        {/* <Typography>tes</Typography> */}
                                        {/* <hr style={{ width: "100%", marginTop: 30, color: 'black', backgroundColor: 'black' }} />
                                    <div style={{ display: 'flex', justifyContent: 'space-between', position: 'relative', width: '100%' }}>
                                        {item.tipe.value === 'Pilihan Ganda' || item.tipe.value === 'Kotak Centang' ?
                                            <div style={{ display: 'flex', width: '60%', cursor: 'pointer' }} onClick={() => handleTambahOpsi(item.opsi, index)}>
                                                <img src={addPertanyaan} style={{ width: 20, height: 20 }} />
                                                <Typography style={{ fontSize: 12, color: 'black', marginLeft: 10 }}>Tambahkan opsi pilihan</Typography>
                                            </div>
                                            : <div style={{ display: 'flex', width: '60%' }} />
                                        }
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', width: '40%' }}>
                                            <img src={ic_note} style={{ width: 20, height: 20, marginRight: 20, cursor: 'pointer' }} />
                                            <img src={tong} style={{ width: 20, height: 20, marginRight: 20, cursor: 'pointer' }} onClick={() => {
                                                pertanyaanLength.opsi.splice(index, 1)
                                                forceUpdate()
                                            }} />
                                            <img src={line} style={{ width: 1, height: 25, marginRight: 20 }} />
                                            <Typography style={{ fontSize: 12, alignContent: 'center', marginTop: 2 }}>Wajib diisi</Typography>
                                            <LightTooltip arrow>
                                                <button style={{
                                                    backgroundColor: "transparent",
                                                    fontSize: 20,
                                                    outline: 'none',
                                                    borderColor: 'transparent',
                                                    marginTop: -7
                                                }}
                                                // onClick={() => handleStatus(tableMeta)}
                                                >
                                                    <IconSwitch checked={false} />
                                                </button>
                                            </LightTooltip>
                                        </div>
                                    </div> */}
                                    </div>
                                </Paper>
                            </div>
                        </div>
                    ))}

                    {pertanyaanLength.opsi && pertanyaanLength.opsi.map((item, index) => (
                        item.subMenu && item.jawaban === "Tambahkan Submenu Pertanyaan" && item.opsi.map((items, indexs) => (
                            items.submenu.value === "Tambahkan Submenu Pertanyaan" ?
                                <div style={{ paddingTop: 30, borderRadius: 20 }}>
                                    <div style={{ width: '100%', borderRadius: 20, boxShadow: '5px 5px 10px 0 #999999', scrollBehavior: true }} >
                                        <Paper style={{ width: "100%", padding: 20 }}>
                                            <div style={{ marginTop: -10 }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <div style={{ width: "70%", borderBottomColor: 'black', borderBottomWidth: 1, borderBottomStyle: 'solid', paddingBottom: 10, alignSelf: 'flex-end' }} >
                                                        <Typography style={{ alignSelf: 'flex-end', fontSize: 20, fontWeight: 'bold' }}>{items.pendukung.pertanyaan}</Typography>
                                                    </div>
                                                    <div style={{ width: "28%", borderBottomColor: 'black', borderBottomWidth: 1, borderBottomStyle: 'solid', alignSelf: 'flex-end' }} >
                                                        <Typography style={{}}>{items.pendukung.tipe.value}</Typography>
                                                    </div>

                                                    {/* <Autocomplete
                                                                options={tipePertanyaan}
                                                                getOptionLabel={(option) => option.value}
                                                                name=''
                                                                id="tipe"
                                                                onChange={(event, newInputValue) => {
                                                                    pertanyaanLength.opsi[index].opsi[indexs].pendukung.tipe = newInputValue
                                                                    forceUpdate()
                                                                }}
                                                                value={i.pendukung.tipe}
                                                                style={{ width: '28%' }}
                                                                renderInput={(params) =>
                                                                    <TextField
                                                                        {...params}
                                                                        InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                                        InputLabelProps={{ style: { color: '#7e8085' } }}
                                                                        label="Tipe Pertanyaan"
                                                                    />
                                                                }
                                                            /> */}
                                                </div>

                                                {pertanyaanLength.opsi[index].opsi[indexs].pendukung.tipe.value === 'Jawaban Singkat' || pertanyaanLength.opsi[index].opsi[indexs].pendukung.tipe.value === 'Jawaban Paragraf' ?
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
                                                        <TextField
                                                            style={{ width: '60%' }}
                                                            id="jawab"
                                                            multiline
                                                            name="jawab"
                                                            required={true}
                                                            // error={errorKodeDokter}
                                                            // helperText={textkodeDokter}
                                                            placeholder={`Exp Jawaban Pertanyaan ${index + 1}`}
                                                            onChange={(e) => {
                                                                pertanyaanLength.opsi[index].opsi[indexs].pendukung.jawaban = e.target.value
                                                            }}
                                                            inputProps={{
                                                                style: {
                                                                    fontSize: 14,
                                                                }
                                                            }}
                                                            InputLabelProps={{
                                                                style: {
                                                                    fontSize: 14,
                                                                    color: '#7e8085',
                                                                }
                                                            }}
                                                            value={items.pendukung.jawaban}
                                                        />

                                                        <TextField
                                                            style={{ width: '28%', alignSelf: 'flex-end' }}
                                                            id="jawab"
                                                            name="jawab"
                                                            disabled
                                                            placeholder={`Skoring`}
                                                            onChange={(e) => {
                                                                pertanyaanLength.opsi[index].opsi[indexs].pendukung.skor = e.target.value
                                                                console.log(pertanyaanLength);
                                                                forceUpdate()
                                                            }}
                                                            inputProps={{
                                                                style: {
                                                                    fontSize: 14,
                                                                }
                                                            }}
                                                            InputLabelProps={{
                                                                style: {
                                                                    fontSize: 14,
                                                                    color: '#7e8085',
                                                                }
                                                            }}
                                                            value={items.pendukung.skor}
                                                        />
                                                    </div>
                                                    :
                                                    pertanyaanLength.opsi[index].opsi[indexs].pendukung.tipe.value === 'Pilihan Ganda' ?
                                                        pertanyaanLength.opsi[index].opsi[indexs].pendukung.opsi && pertanyaanLength.opsi[index].opsi[indexs].pendukung.opsi.map((itemss, indexss) => (
                                                            pertanyaanLength.opsi[index].opsi[indexs].pendukung.subMenu ?
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
                                                                    <div style={{ display: 'flex', width: '60%' }}>
                                                                        <GreenRadio
                                                                            checked={pertanyaanLength.opsi[index].opsi[indexs].pendukung.jawaban === itemss.submenu.value ? true : false}
                                                                            onChange={(e) => {
                                                                                pertanyaanLength.opsi[index].opsi[indexs].pendukung.jawaban = itemss.submenu !== "" ? itemss.submenu.value : ""
                                                                                console.log(pertanyaanLength);
                                                                                forceUpdate()
                                                                            }}
                                                                            // value="c"
                                                                            name="radio"
                                                                            style={{ padding: 0 }}
                                                                            inputProps={{ 'aria-label': 'C' }}
                                                                        />
                                                                        <TextField
                                                                            style={{ marginLeft: 10, width: '60%' }}
                                                                            id="jawab"
                                                                            name="jawab"
                                                                            required={true}
                                                                            disabled
                                                                            placeholder={`Opsi Pilihan ${indexss + 1}`}
                                                                            onChange={(e) => {
                                                                                pertanyaanLength.opsi[index].opsi[indexs].pendukung.opsi[indexss].jawaban = e.target.value
                                                                                console.log(pertanyaanLength);
                                                                                forceUpdate()
                                                                            }}
                                                                            inputProps={{
                                                                                style: {
                                                                                    fontSize: 14,
                                                                                }
                                                                            }}
                                                                            InputLabelProps={{
                                                                                style: {
                                                                                    fontSize: 14,
                                                                                    color: '#7e8085',
                                                                                }
                                                                            }}
                                                                            value={itemss.jawaban}
                                                                        />
                                                                    </div>

                                                                    <TextField
                                                                        style={{ width: '28%', alignSelf: 'flex-end' }}
                                                                        id="jawab"
                                                                        name="jawab"
                                                                        disabled
                                                                        placeholder={`Skoring`}
                                                                        onChange={(e) => {
                                                                            pertanyaanLength.opsi[index].opsi[indexs].pendukung.opsi[indexs].skor = e.target.value
                                                                            console.log(pertanyaanLength);
                                                                            forceUpdate()
                                                                        }}
                                                                        inputProps={{
                                                                            style: {
                                                                                fontSize: 14,
                                                                            }
                                                                        }}
                                                                        InputLabelProps={{
                                                                            style: {
                                                                                fontSize: 14,
                                                                                color: '#7e8085',
                                                                            }
                                                                        }}
                                                                        value={itemss.skor}
                                                                    />
                                                                </div> :
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
                                                                    <div style={{ display: 'flex', width: '60%' }}>
                                                                        <GreenRadio
                                                                            checked={pertanyaanLength.opsi[index].opsi[indexs].pendukung.jawaban === itemss.jawaban ? true : false}
                                                                            onChange={(e) => {
                                                                                pertanyaanLength.opsi[index].opsi[indexs].pendukung.jawaban = itemss.jawaban
                                                                                console.log(pertanyaanLength);
                                                                                forceUpdate()
                                                                            }}
                                                                            // value="c"
                                                                            name="radio"
                                                                            style={{ padding: 0 }}
                                                                            inputProps={{ 'aria-label': 'C' }}
                                                                        />
                                                                        <TextField
                                                                            style={{ marginLeft: 10, width: '60%' }}
                                                                            id="jawab"
                                                                            name="jawab"
                                                                            disabled
                                                                            placeholder={`Opsi Pilihan ${indexss + 1}`}
                                                                            onChange={(e) => {
                                                                                pertanyaanLength.opsi[index].opsi[indexs].pendukung.opsi[indexss].jawaban = e.target.value
                                                                                console.log(pertanyaanLength);
                                                                                forceUpdate()
                                                                            }}
                                                                            inputProps={{
                                                                                style: {
                                                                                    fontSize: 14,
                                                                                }
                                                                            }}
                                                                            InputLabelProps={{
                                                                                style: {
                                                                                    fontSize: 14,
                                                                                    color: '#7e8085',
                                                                                }
                                                                            }}
                                                                            value={itemss.jawaban}
                                                                        />
                                                                    </div>

                                                                    <TextField
                                                                        style={{ width: '28%', alignSelf: 'flex-end' }}
                                                                        id="jawab"
                                                                        name="jawab"
                                                                        disabled
                                                                        placeholder={`Skoring`}
                                                                        onChange={(e) => {
                                                                            pertanyaanLength.opsi[index].opsi[indexs].pendukung.opsi[indexs].skor = e.target.value
                                                                            console.log(pertanyaanLength);
                                                                            forceUpdate()
                                                                        }}
                                                                        inputProps={{
                                                                            style: {
                                                                                fontSize: 14,
                                                                            }
                                                                        }}
                                                                        InputLabelProps={{
                                                                            style: {
                                                                                fontSize: 14,
                                                                                color: '#7e8085',
                                                                            }
                                                                        }}
                                                                        value={itemss.skor}
                                                                    />
                                                                </div>
                                                        ))
                                                        :
                                                        pertanyaanLength.opsi[index].opsi[indexs].pendukung.tipe.value === 'Kotak Centang' ?
                                                            pertanyaanLength.opsi[index].opsi[indexs].pendukung.opsi && pertanyaanLength.opsi[index].opsi[indexs].pendukung.opsi.map((itemss, indexss) => (
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
                                                                    <div style={{ display: 'flex', width: '60%' }}>
                                                                        <FormControlLabel
                                                                            style={{ padding: 0, margin: 0 }}
                                                                            control={
                                                                                <GreenCheckbox
                                                                                    checked={handleCheckboxSub(index, indexs, indexss)}
                                                                                    onChange={() => {
                                                                                        handleCheckSub(itemss.jawaban, index, indexs, indexss)
                                                                                        forceUpdate()
                                                                                    }}
                                                                                    name="checked" />}
                                                                            label=""
                                                                        />
                                                                        <TextField
                                                                            style={{ marginLeft: 10, width: '95%' }}
                                                                            id="jawab"
                                                                            name="jawab"
                                                                            disabled
                                                                            placeholder={`Opsi Pilihan ${indexss + 1}`}
                                                                            onChange={(e) => {
                                                                                pertanyaanLength.opsi[index].opsi[indexs].pendukung.opsi[indexss].jawaban = e.target.value
                                                                                console.log(pertanyaanLength);
                                                                                forceUpdate()
                                                                            }}
                                                                            inputProps={{
                                                                                style: {
                                                                                    fontSize: 14,
                                                                                }
                                                                            }}
                                                                            InputLabelProps={{
                                                                                style: {
                                                                                    fontSize: 14,
                                                                                    color: '#7e8085',
                                                                                }
                                                                            }}
                                                                            value={itemss.jawaban}
                                                                        />
                                                                    </div>
                                                                    <TextField
                                                                        style={{ width: '28%' }}
                                                                        id="jawab"
                                                                        name="jawab"
                                                                        required={true}
                                                                        placeholder={`Skoring`}
                                                                        onChange={(e) => {
                                                                            pertanyaanLength.opsi[index].opsi[indexs].pendukung.opsi[indexss].skor = e.target.value
                                                                            console.log(pertanyaanLength);
                                                                            forceUpdate()
                                                                        }}
                                                                        inputProps={{
                                                                            style: {
                                                                                fontSize: 14,
                                                                            }
                                                                        }}
                                                                        InputLabelProps={{
                                                                            style: {
                                                                                fontSize: 14,
                                                                                color: '#7e8085',
                                                                            }
                                                                        }}
                                                                        value={itemss.skor}
                                                                    />
                                                                </div>
                                                            ))
                                                            :
                                                            pertanyaanLength.opsi[index].opsi[indexs].pendukung.tipe.value === 'Tanggal' ?
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
                                                                    <div style={{ borderBottomColor: '#ebebeb', borderBottomStyle: 'solid', borderBottomWidth: 1, display: 'flex', width: '60%' }}>
                                                                        <img src={iconDate} style={{ width: 20, height: 20, alignSelf: 'center' }} />
                                                                        <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ margin: 0 }}>
                                                                            <DatePicker
                                                                                margin="normal"
                                                                                id="validFrom"
                                                                                label=""
                                                                                format="dd MMM yyyy"
                                                                                value={new Date()}
                                                                                onChange={(date) => {
                                                                                    pertanyaanLength.opsi[index].opsi[indexs].pendukung.jawaban = new Date(date).toLocaleDateString()
                                                                                    console.log(pertanyaanLength);
                                                                                    forceUpdate()
                                                                                }}
                                                                                KeyboardButtonProps={{
                                                                                    'aria-label': 'change date',
                                                                                }}
                                                                                style={{ width: '100%', margin: '0px 0px 0px 20px', padding: 0 }}
                                                                            />
                                                                        </MuiPickersUtilsProvider>
                                                                    </div>
                                                                    <TextField
                                                                        style={{ width: '28%', alignSelf: 'flex-end' }}
                                                                        id="jawab"
                                                                        name="jawab"
                                                                        disabled
                                                                        placeholder={`Skoring`}
                                                                        onChange={(e) => {
                                                                            pertanyaanLength.opsi[index].opsi[indexs].pendukung.skor = e.target.value
                                                                            console.log(pertanyaanLength);
                                                                            forceUpdate()
                                                                        }}
                                                                        inputProps={{
                                                                            style: {
                                                                                fontSize: 14,
                                                                            }
                                                                        }}
                                                                        InputLabelProps={{
                                                                            style: {
                                                                                fontSize: 14,
                                                                                color: '#7e8085',
                                                                            }
                                                                        }}
                                                                        value={items.pendukung.skor}
                                                                    />
                                                                </div>
                                                                :
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
                                                                    <TextField
                                                                        style={{ width: '60%' }}
                                                                        id="jawab"
                                                                        name="jawab"
                                                                        disabled
                                                                        required={true}
                                                                        placeholder={`Exp Jawaban Pertanyaan ${index + 1}`}
                                                                        onChange={(e) => {
                                                                            // handleSetPertanyaan(e.target.value, index)
                                                                        }}
                                                                        inputProps={{
                                                                            style: {
                                                                                fontSize: 14,
                                                                            }
                                                                        }}
                                                                        InputLabelProps={{
                                                                            style: {
                                                                                fontSize: 14,
                                                                                color: '#7e8085',
                                                                            }
                                                                        }}
                                                                        value={items.jawaban}
                                                                    />

                                                                    <div style={{ width: '28%', borderBottomColor: 'black', borderBottomWidth: 1, borderBottomStyle: 'solid', alignSelf: 'flex-end' }} >
                                                                        <Typography style={{}}>Skoring</Typography>
                                                                    </div>
                                                                </div>
                                                }
                                                {/* <Typography>tes</Typography> */}
                                                {/* <hr style={{ width: "100%", marginTop: 30, color: 'black', backgroundColor: 'black' }} />
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', position: 'relative', width: '100%' }}>
                                                            {i.pendukung.tipe.value === 'Pilihan Ganda' || i.pendukung.tipe.value === 'Kotak Centang' ?
                                                                <div style={{ display: 'flex', width: '60%' }} >
                                                                    <div style={{ display: 'flex', cursor: 'pointer', alignItems: 'center' }} onClick={() => {
                                                                        i.pendukung.opsi.push({
                                                                            jawaban: "",
                                                                            skor: ""
                                                                        })
                                                                        forceUpdate()
                                                                    }}>
                                                                        <img src={addPertanyaan} style={{ width: 20, height: 20 }} />
                                                                        <Typography style={{ fontSize: 12, color: 'black', marginLeft: 10 }}>Tambahkan opsi pilihan</Typography>
                                                                    </div>
                                                                    <div style={{ borderLeftColor: '#278863', borderLeftWidth: 1, borderLeftStyle: 'solid', marginLeft: 20 }} />
                                                                    <div style={{ display: 'flex', cursor: 'pointer', marginLeft: 20, alignItems: 'center' }}
                                                                        onClick={() => {
                                                                            pertanyaanLength.opsi[index].opsi[indexs].pendukung.subMenu = !i.pendukung.subMenu
                                                                            forceUpdate()
                                                                        }}>
                                                                        <GreenCheckbox checked={pertanyaanLength.opsi[index].opsi[indexs].pendukung.subMenu} onChange={() => null} name="checked" style={{ padding: 0, margin: 0 }} />
                                                                        <Typography style={{ fontSize: 12, color: 'black', marginLeft: 10 }}>Tambahkan Sub Menu</Typography>
                                                                    </div>
                                                                </div>
                                                                : <div style={{ display: 'flex', width: '60%' }} />
                                                            }
                                                            <div style={{ display: 'flex', justifyContent: 'flex-end', width: '40%' }}>
                                                                <img src={ic_note} style={{ width: 20, height: 20, marginRight: 20, cursor: 'pointer' }} />
                                                                <img src={tong} style={{ width: 20, height: 20, marginRight: 20, cursor: 'pointer' }} onClick={() => {
                                                                    pertanyaanLength.opsi[index].opsi[indexs].pendukung = {}
                                                                    pertanyaanLength.opsi[index].opsi[indexs].submenu = ""
                                                                    forceUpdate()
                                                                }} />
                                                                <img src={line} style={{ width: 1, height: 25, marginRight: 20 }} />
                                                                <Typography style={{ fontSize: 12, alignContent: 'center', marginTop: 2 }}>Wajib diisi</Typography>
                                                                <LightTooltip arrow>
                                                                    <button style={{
                                                                        backgroundColor: "transparent",
                                                                        fontSize: 20,
                                                                        outline: 'none',
                                                                        borderColor: 'transparent',
                                                                        marginTop: -7
                                                                    }}
                                                                    // onClick={() => handleStatus(tableMeta)}
                                                                    >
                                                                        <IconSwitch checked={false} />
                                                                    </button>
                                                                </LightTooltip>
                                                            </div>
                                                        </div> */}
                                            </div>
                                        </Paper>
                                    </div>
                                </div>
                                : null
                        ))
                    ))}

                    <div style={{ marginTop: 40, display: 'flex', justifyContent: 'flex-end' }}>
                        <div style={{ backgroundColor: 'transparent', borderRadius: 30, padding: 6, width: 168, textAlign: 'center', cursor: 'pointer' }}
                            onClick={() => props.backToCreate()}>
                            <Typography style={{ color: '#c1c1c1', fontSize: 20 }}>Batal</Typography>
                        </div>
                        <div style={{ backgroundColor: '#278863', borderRadius: 30, padding: 6, width: 168, textAlign: 'center', cursor: 'pointer' }}
                            onClick={() => {
                                if (pertanyaanLength.kategori.length > 0) {
                                    handleArrayOpsi()
                                    setVisibleSkrining(false)
                                    setVisibleKategoriSkrining(true)
                                } else {
                                    handleArrayOpsi()
                                }
                            }}>
                            <Typography style={{ color: 'white', fontSize: 20 }}>Berikutnya</Typography>
                        </div>
                    </div>
                </div>
            )}

            {visibleKategoriSkrining && (
                <PreviewKategoriSkrining
                    dataKategori={pertanyaanLength.kategori}
                    arraySkirining={pertanyaanLength}
                    onBack={() => {
                        setVisibleSkrining(true)
                        setVisibleKategoriSkrining(false)
                    }}
                />
            )}
        </div>
    )
}